<template>
	<div>
		<div class="columns is-multiline is-centered has-background-white">
			<div class="column is-full">
				<p
					v-if="mode == 'add'"
					class="has-text-centered has-text-weight-bold is-size-4 p-3">
					Your Review of this Product
				</p>
				<p
					v-if="mode == 'edit'"
					class="has-text-centered has-text-weight-bold is-size-4 p-3">
					What is your review of this product now?
				</p>
				<div class="columns is-centered is-vcentered">
					<div class="column is-narrow is-size-5">Rate this Product</div>
					<div class="column is-narrow">
						<star-rating-input
							ref="starRating"
							:text_size_prop="4"
							:mode_prop="mode"></star-rating-input>
					</div>
				</div>
			</div>
			<div class="column is-10">
				<div class="columns is-multiline">
					<div class="column is-4">
						<div class="columns">
							<div class="column is-full">
								<image-manager
									ref="imageManager"
									:mode_prop="mode"></image-manager>
							</div>
						</div>
					</div>
					<div class="column is-8">
						<div class="columns is-multiline">
							<div class="column is-full">
								<rich-text-editor
									ref="richTextEditor"
									class="mr-2"
									:canResizeVertically_prop="false"
									:isMaxHeight_prop="false"
									:placeholder_prop="placeholder_prop"
									:maxCharacterLength_prop="400"></rich-text-editor>
							</div>
							<div class="column is-full mt-1">
								<div class="columns is-vcentered">
									<div class="column"></div>
									<div
										class="column is-narrow"
										:class="{ 'mt-1': showCodeInput }">
										<p
											class="has-text-left"
											:class="{ 'pt-4': !showCodeInput }">
											<span v-if="showCodeInput">
												<form-standard-input
													ref="receiptCode"
													:limit_prop="15"
													label_prop="Receipt Code"
													description_prop="If you are not a logged in user you can still leave a review of the product by entering the code you got on your receipt."
													placeholder_prop="Receipt Code e.g. 12E4S6T8P"></form-standard-input>
											</span>
											<span
												v-else
												class="is-size-7 has-text-grey">
												Logged in and Product Purchase Detected!<br />Review
												can be made without code.
											</span>
										</p>
									</div>
									<div class="column is-narrow">
										<p
											@click="clearReviewSectionPrompt"
											class="has-text-weight-bold has-text-centered mt-0 mb-1 is-hidden">
											<a class="has-text-danger"
												><i class="fas fa-eraser"></i
												>&nbsp;&nbsp;Erase Review Writer</a
											>
										</p>
										<button
											ref="submitButton"
											@click="submitReview"
											class="button is-warning is-medium mt-5">
											Submit Review&nbsp;&nbsp;<i
												class="fas fa-paper-plane"></i>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="column is-full has-text-centered">
						<a
							v-if="hasHideWriterButton"
							@click="$emit('expand-review-section')"
							class="has-text-info has-text-weight-bold"
							><i class="fas fa-eye-slash"></i>&nbsp;&nbsp;Hide Review
							Writer</a
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped></style>
<script>
	import axios from "axios";
	axios.defaults.headers.post["X-CSRF-TOKEN"] = window.csrf_token;
	import StarRatingInput from "./StarRatingInput.vue";
	import RichTextEditor from "../GeneralInputComponents/RichTextEditor.vue";
	import FormStandardInput from "../GeneralInputComponents/FormStandardInput.vue";
	import ImageManager from "../ImageManager/ImageManager.vue";

	export default {
		components: {
			FormStandardInput,
			ImageManager,
			RichTextEditor,
			StarRatingInput,
		},
		emits: [
			"update-review-section",
			"expand-review-section",
			"form-submitted-successfully",
		],
		props: {
			mode_prop: String,
			placeholder_prop: String,
			review_link_prop: String,
			product_id_prop: Number,
			is_logged_in_prop: Boolean,
			has_hide_writer_button_prop: Boolean,
			review_prop: Object,
			transaction_code_prop: String,
		},
		data() {
			return {
				useCode: false,
			};
		},
		computed: {
			hasHideWriterButton() {
				return this.$props.has_hide_writer_button_prop;
			},
			mode() {
				switch (this.mode_prop) {
					case "edit":
						return "edit";
						break;
				}
				return "add";
			},
			showCodeInput() {
				if (this.useCode) {
					return true;
				} else if (this.isLoggedIn && !this.useCode) {
					return false;
				} else {
					return true;
				}
			},
			isLoggedIn() {
				if (JSON.parse(window.sessionStorage.getItem("logged_in")).value) {
					return true;
				} else if (this.$props.is_logged_in_prop) {
					return this.$props.is_logged_in_prop;
				}
				return false;
			},
			review() {
				return this.$props.review_prop;
			},
			transaction_code() {
				if (typeof this.$props.transaction_code_prop == "string") {
					return this.$props.transaction_code_prop;
				} else {
					return "";
				}
			},
		},
		mounted() {
			let _this = this;
			if (_this.isLoggedIn) {
				if (_this.mode == "add") {
					axios
						.post(_this.$props.review_link_prop, {
							method: "create_check",
							product: _this.$props.product_id_prop,
						})
						.then(function (res) {
							console.log(res);
							if (res.data.can_create) {
								_this.useCode = false;
							} else {
								_this.useCode = true;
							}
						})
						.catch(function (res) {
							console.log(res);
							_this.useCode = true;
						});
				}
			}
		},
		methods: {
			placeholder() {
				return this.$props.placeholder_prop
					? this.$props.placeholder_prop
					: "";
			},
			clearReviewSectionPrompt() {
				this.$buefy.dialog.confirm({
					title: "Clear Review",
					message:
						"<p>Are you sure you want to remove what you've entered for your review?</p><br/><p>Data entered for this review will be lost!</p>",
					confirmText: "Erase",
					type: "is-danger",
					hasIcon: true,
					onConfirm: () => {
						this.clearReviewSection();
					},
				});
			},
			clearReviewSection() {
				this.$refs.imageManager.clear();
				this.$refs.richTextEditor.clear();
				if (this.$refs.receiptCode) {
					this.$refs.receiptCode.clear();
				}
				this.$refs.starRating.rating = 0;
			},
			load(payload) {
				let _this = this;
				this.$refs.richTextEditor.setHTML(payload.content.description);
				if (payload.code) {
					this.useCode = true;
					this.$nextTick(() => {
						_this.$refs.imageManager.load(payload.content.images);
						_this.$refs.receiptCode.value(payload.code);
					});
				}
				this.$refs.starRating.value(payload.rating);
			},
			toggleReviewSection() {
				this.enableReviewInput = !this.enableReviewInput;
			},
			form() {
				let _this = this;
				let form = new FormData();

				form.append("type", "product");
				form.append("rating", this.$refs.starRating.value());
				form.append("description", this.$refs.richTextEditor.getHTML());
				form.append("id", this.$props.product_id_prop);
				if (this.$refs.receiptCode) {
					form.append("receipt", this.$refs.receiptCode.value());
				}

				//Gather All Images that need uploading
				let images = [];
				let image_count = 0;
				this.$refs.imageManager.details().forEach((image, index) => {
					if (typeof image == "object") {
						if (_this.mode == "add") {
							form.append(`image_${image_count++}`, image);
						}
						if (_this.mode == "edit") {
							form.append(`image_${image_count++}`, image.file);
						}
					} else if (typeof image == "string") {
						images.push(image);
					}
				});

				form.append("images", JSON.stringify(images));

				//Add Number of images to form
				form.append("images_length", image_count);

				switch (this.mode) {
					case "add":
						form.append("method", "create");
						break;
					case "edit":
						form.append("method", "edit");
						form.append("transaction_code", this.transaction_code);
						form.append("id", this.$props.product_id_prop);
						form.append("updated_at", _this.review.updated_at);
						form.append(
							"old_description",
							_this.review.content.description
						);
						break;
				}

				return form;
			},
			submitReview() {
				let _this = this;
				_this.$refs.submitButton.classList.add("is-loading");
				_this.$refs.submitButton.setAttribute("disabled", true);
				axios
					.post(_this.$props.review_link_prop, _this.form(), {
						headers: { "Content-Type": "multipart/form-data" },
					})
					.then(function (res) {
						_this.clearReviewSection();
						_this.toggleReviewSection();
						_this.$emit("update-review-section", "");
						_this.$emit("form-submitted-successfully", "");
						_this.$buefy.dialog.alert({
							type: "is-success",
							title: "Review Created!",
							hasIcon: true,
							message: "Your Review has been submitted",
						});
					})
					.catch(function (error) {
						let message =
							"An error has occured when submitting your review, please try agian later";
						_this.$buefy.dialog.alert({
							type: "is-danger",
							title: "Error!",
							hasIcon: true,
							message: message,
						});
					})
					.then(function (res) {
						_this.$refs.submitButton.classList.remove("is-loading");
						_this.$refs.submitButton.removeAttribute("disabled");
					});
			},
		},
	};
</script>
